<div class="login-alert-widget-notification">
    <db-app-alert-widget-root></db-app-alert-widget-root>
</div>



// WEBPACK FOOTER //
// ./src/app/app.component.html